import React, { useState, useEffect } from 'react';
import Table from '../common/Table';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import Ratings from '../common/Rating';
import Type from '../common/Types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { useHistory } from "react-router-dom";
import Loader from '../common/Loader';
import Button from '../common/Button';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer,
} from "react-google-maps";
import { compose, withProps, lifecycle } from "recompose";
import { useParams } from "react-router-dom";
import { getOrderDetailsById } from '../../actions/orders';
import Grid from '@material-ui/core/Grid';


const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#43a047',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);


const MapWithADirectionsRenderer = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAHY1OfyO7pJuMCExcycBYR9nVLK3zmJOE&v=3.exp&libraries=geometry,drawing,places,directions",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
  lifecycle({
    componentDidMount() {
      const DirectionsService = new google.maps.DirectionsService();

      DirectionsService.route({
        origin: new google.maps.LatLng(41.8507300, -87.6512600),
        destination: new google.maps.LatLng(41.8525800, -87.6514100),
        travelMode: google.maps.TravelMode.DRIVING,
      }, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result,
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      });
    }
  })
)(props =>
  <GoogleMap
    defaultZoom={7}
    defaultCenter={new google.maps.LatLng(41.8507300, -87.6512600)}
  >
    {props.directions && <DirectionsRenderer directions={props.directions} />}
  </GoogleMap>
);

const ChefAndRestaurantProfile = (props) => {
  const classes = props.classes;
  const history = useHistory();
  const params = useParams();
  let orderId = params.id;
  const [orderdet, setOrderDet] = useState([]);
  const [itemdet, setItemDet] = useState([]);
  const [msg, setMsg] = useState("");
  const [msgstatus, setMsgStatus] = useState("");
  const [state, setState] = useState({
    users: true,
    chefs: false,
    restaurants: false,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    getOrderDetailsById(orderId).then((response) => {
      console.log("order details", response);
      setMsgStatus(response.data.status);
      setMsg(response.data.ResponseText);
      setOrderDet(response.data.ResponseData === null ? '' : response.data.ResponseData.data[0]);
      setItemDet(response.data.details.items === null ? '' : response.data.details.items);

    })
  }, []);
  return (
    <div style={{ width: '100%' }}>
      <Box display="flex" p={1} className="mb-3" justifyContent="flex-end">
        <Button onClick={() => { history.goBack(); }} size="small" label="Back"></Button>
      </Box>
      <React.Fragment>
        {msgstatus === "error" && <div className={classes.errorwrap}><h1>{msg}</h1></div>}
        {(msgstatus != "error" && orderdet.length === 0) && <Loader />}
        <div className={classes.wrap}>
          <div className={classes.section1}>
            {orderdet != "" &&
              <Card className={classes.root}>
                <CardContent classes={{ root: classes.contentWrapper }}>
                  <h2 className={'mb-3 mt-3 ml-3'}> <strong>Order Details</strong> </h2>
                  <Divider classes={{ root: classes.dividerRoot }} />
                  <div className={classes.profileDetails}>
                    <Grid container spacing={3} className={'mt-3 '}>
                      <Grid item xs={4}><label> Order ID</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.order_id ? orderdet.order_id : ""}</strong></label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Total Dishes</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.cart ? orderdet.cart.no_of_items : "0"}</strong></label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Order Status</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.order_status ? orderdet.order_status : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Order Date</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.order_date_local ? orderdet.order_date_local : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Resaturant Name</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.food_seller !== null ? orderdet.food_seller.business_name : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Resaturant Contact No</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.sellerMobileNo ? orderdet.sellerMobileNo : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Buyer Name</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.food_buyer.user !== null ? orderdet.food_buyer.user.name : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Buyer Contact No</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.food_buyer.user !== null ? orderdet.food_buyer.user.mobile_no : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Agent Name</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.agentName ? orderdet.agentName : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Agent Contact No</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.agentMobileNo ? orderdet.agentMobileNo : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Delivery Address</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label style={{ display: "inline", wordWrap: "break-word" }}> <strong>{orderdet.delivery_address ? orderdet.delivery_address.address : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Delivery Assigned  To</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.deliveryAssignedTo ? orderdet.deliveryAssignedTo : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label> Delivery Assigned Status</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.deliveryAssignedStatus ? orderdet.deliveryAssignedStatus : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Delivery Option Name</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.delivery_option ? orderdet.delivery_option.option_name : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Amount</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.amount ? orderdet.amount : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Delivery Charges</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.deliveryCharges ? orderdet.deliveryCharges : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Shipping Charges</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.shippingCharges ? orderdet.shippingCharges : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Payment Method</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.order_payment ? orderdet.order_payment.method : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Coupon Discount</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.couponDiscount ? orderdet.couponDiscount : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Cash Back</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.cashBack ? orderdet.cashBack : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Discount</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.discount ? orderdet.discount : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Total Amount</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.netAmount ? orderdet.netAmount : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>{orderdet.taxName ? orderdet.taxName : "Tax"}</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.tax ? orderdet.tax : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Convenience Fees</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.convenienceFees ? orderdet.convenienceFees : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Amount Paid</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label><strong>{(orderdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.paymentAmount ? orderdet.paymentAmount : "0.0"}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Payment Method</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.order_payment !== null ? orderdet.order_payment.method : ""}</strong> </label></Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={4}><label>Payment Status</label></Grid>
                      <Grid item xs={1}><label><strong>:</strong></label></Grid>
                      <Grid item xs={6}><label> <strong>{orderdet.order_payment !== null ? orderdet.order_payment.payment_status : ""}</strong> </label></Grid>
                    </Grid>
                  </div>
                </CardContent>
              </Card>
            }
          </div>
          <div className={classes.section2}>
            {orderdet != "" &&
              <Card className={`${classes.root}`}>
                <CardContent>
                  <h2 className={'mb-3'}> <strong>Dishes Details</strong> </h2>
                  <Divider classes={{ root: classes.dividerRoot }} />
                  <div style={{ width: '100%' }}>
                    {itemdet.map((s, t) => {
                      return (
                        <div>
                          <Grid container spacing={3} className={'mb-3 mt-3 '}>
                            <Grid item xs={6}>
                              <div className={classes.cardContent}>
                                <img src={s.imageUrl} className={classes.profile} style={{ width: '80%', height: '80%' }} />
                              </div>
                            </Grid>
                            <Grid item xs={6}>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Dish Name</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{s.itemName}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Weight</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{s.weight}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Quantity</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{s.quantity}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Price Per Dish</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.price}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Amount</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.amount}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>CashBack</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.cashBack}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Coupon Code</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{s.couponCode}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Discount</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.discount}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Refund Amount</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.refundAmount}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Total Amount</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.netAmount}</strong></label></Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={4}><label>Fulfillment Status</label></Grid>
                                <Grid item xs={1}><label><strong>:</strong></label></Grid>
                                <Grid item xs={7}><label><strong>{s.fulfillmentStatus}</strong></label></Grid>
                              </Grid>

                            </Grid>
                          </Grid>
                          <Divider classes={{ root: classes.dividerRoot }} />
                        </div>
                      );
                    })}


                  </div>

                  {/* <MapWithADirectionsRenderer/> */}
                </CardContent>
              </Card>
            }
          </div>
        </div>
      </React.Fragment>
    </div>
  )
};

export default ChefAndRestaurantProfile;
